export default __webpack_public_path__ + "static/media/mongodb.aeeb7273.svg";